import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import WorkerLocationStatusIcon from './scheduler/WorkerLocationStatusIcon';

const EMPTY_WORKER_IDS = new Set();

function getWorkerWorkload(workerWorkloadCounts, workerId) {
    const workload = workerWorkloadCounts?.[workerId] || {};
    const incompleteCleaning = Number(workload.incompleteCleaning) || 0;
    const completedCleaning = Number(workload.completedCleaning) || 0;
    const tasks = Number(workload.tasks) || 0;

    return {
        incompleteCleaning,
        completedCleaning,
        tasks,
        total: incompleteCleaning + completedCleaning + tasks,
    };
}

function getWorkloadLabel(workerName, workload) {
    const jobLabel = workload.total === 1 ? 'job' : 'jobs';

    return `${workerName}: ${workload.total} assigned ${jobLabel} (${workload.incompleteCleaning} incomplete cleaning, ${workload.completedCleaning} completed cleaning, ${workload.tasks} tasks)`;
}

function getVisibleWorkloadCounts(workload) {
    return workload.total > 0
        ? [workload.incompleteCleaning, workload.completedCleaning, workload.tasks].join(',')
        : '';
}

export default function ActiveWorkerToggleGroup({
                                                    activeWorkerId,
                                                    setActiveWorkerId,
                                                    workerWorkloadCounts,
                                                    workerStatusCount,
                                                    fieldWorkerMap,
                                                    fieldWorkerArray = [],
                                                    showWorkerLocation = false,
                                                    todayWorkerIds = EMPTY_WORKER_IDS,
                                                }) {
    return (
        <div>


            <ButtonGroup className="scheduler-worker-toggle-group">
                {fieldWorkerArray.filter((worker) => worker.isDeleted !== true).map((radio, idx) => {
                    const workload = workerWorkloadCounts
                        ? getWorkerWorkload(workerWorkloadCounts, radio.id)
                        : null;
                    const workloadLabel = workload ? getWorkloadLabel(radio.name, workload) : undefined;
                    const visibleWorkloadCounts = workload ? getVisibleWorkloadCounts(workload) : '';
                    const hasGpsStatus = showWorkerLocation
                        && todayWorkerIds.has(String(radio.id))
                        && radio.locationTracking?.app_reported === true;

                    return (
                        <ToggleButton
                            className={`rounded-pill${hasGpsStatus ? " has-gps" : ""}`}
                            key={radio.id ?? idx}
                            id={`workerradio-${idx}`}
                            type="radio"
                            variant="outline-secondary"
                            name="radio1"
                            value={radio.id}
                            checked={(activeWorkerId + '') === (radio.id + '')}
                            aria-label={workloadLabel}
                            title={workloadLabel}
                            onChange={(e) => setActiveWorkerId(e.currentTarget.value)}
                        >
                            {workload ? (
                                <span className="scheduler-worker-toggle-content">
                                    <span className="scheduler-worker-name">
                                        {hasGpsStatus ? (
                                            <WorkerLocationStatusIcon
                                                tracking={radio.locationTracking}
                                                workerName={radio.name}
                                            />
                                        ) : null}
                                        <span>{radio.name}</span>
                                    </span>
                                    {visibleWorkloadCounts ? (
                                        <span className="scheduler-worker-count" aria-hidden="true">
                                            {visibleWorkloadCounts}
                                        </span>
                                    ) : null}
                                </span>
                            ) : workerStatusCount?.[radio.id] ?
                                <div>{radio.name}<span style={{color: "blue"}}>{ ' (' + workerStatusCount[radio.id] + ') '}</span></div> :
                                radio.name + '    '}
                        </ToggleButton>
                    );
                })}
            </ButtonGroup>
        </div>
    );
}
